import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.REACT_APP_ENVIRONMENT.toLowerCase() === "production") {
	console.log = () => {};
	console.error = () => {};
	console.table = () => {};
	console.debug = () => {};
	console.time = () => {};
	console.timeEnd = () => {};
}

root.render(
    <App />
);

